import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginGuardService } from './common/loginguard.service'; 

import { DashboardComponent } from './dashboard/dashboard.component';
// import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
// import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SuperadminDashboardComponent } from './dashboard/superadmin-dashboard/superadmin-dashboard.component';
import { AdmindashboardComponent } from './dashboard/admindashboard/admindashboard.component';
import { ManagementdashboardComponent } from './dashboard/managementdashboard/managementdashboard.component';
import { RegistrardashboardComponent } from './dashboard/registrardashboard/registrardashboard.component';
import { LecturerdashboardComponent } from './dashboard/lecturerdashboard/lecturerdashboard.component';
import { QadashboardComponent } from './dashboard/qadashboard/qadashboard.component';
import { HoddashboardComponent } from './dashboard/hoddashboard/hoddashboard.component';



// Other Module Components 
import { RolemanagementComponent } from './dashboard/superadmin-dashboard/superadminpages/rolemanagement/rolemanagement.component';
import { SuperloginComponent } from './superlogin/superlogin.component';
import { UseraccountsComponent } from './dashboard/superadmin-dashboard/superadminpages/useraccounts/useraccounts.component';
import { NewsignupsComponent } from './newsignups/newsignups.component';
import { ApplicationreviewComponent } from './applicationreview/applicationreview.component';
import { FinancedashboardComponent } from './financedashboard/financedashboard.component';
import { ApplicationfeesdashboardComponent } from './applicationfeesdashboard/applicationfeesdashboard.component';
import { AddfeesitemsComponent } from './addfeesitems/addfeesitems.component';
import { ApplicantfromoldappComponent } from './applicantfromoldapp/applicantfromoldapp.component';



const routes: Routes = [
  { path: '', redirectTo: '/super-login', pathMatch: 'full' },
  { path: 'super-login', component: SuperloginComponent },
  // { path: 'reset-password', component: ResetPasswordComponent },

  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [LoginGuardService], 
    children: [
      // ----------------------------------------------------
      // Child Routes for Role-Specific Dashboard Views 
      // ----------------------------------------------------
      { 
        path: 'sysadmin-dashboard', 
        component: SuperadminDashboardComponent 
      },
      { 
        path: 'qa-dashboard', 
        component: QadashboardComponent 
      },
      { 
        path: 'admin-dashboard', 
        component: AdmindashboardComponent 
      },
      { 
        path: 'management-dashboard', 
        component: ManagementdashboardComponent 
      },
      { 
        path: 'registrar-dashboard', 
        component: RegistrardashboardComponent 
      },
      { 
        path: 'lecturer-dashboard', 
        component: LecturerdashboardComponent 
      },
      { 
        path: 'hod-dashboard',
        component: HoddashboardComponent 
      },

      { 
        path: 'accountant-dashboard',
        component: FinancedashboardComponent 
      },
      {
        path:'new-applications',
        component:NewsignupsComponent
      },

        {
        path:'application-review',
        component:ApplicationreviewComponent
      },
      { 
        path: 'application-fees', 
        component: ApplicationfeesdashboardComponent 
      },

       { 
        path: 'add-fees-items', 
        component: AddfeesitemsComponent 
      },

        { 
        path: 'applicants-from-old-app', 
        component: ApplicantfromoldappComponent 
      },

      // { 
      //   path: 'exam-officer-dashboard', 
      //   component: ExamOfficerdashboardComponent 
      // },
      // { 
      //   path: 'librarian-dashboard', 
      //   component: LibrariandashboardComponent 
      // },

      // ----------------------------------------------------
      // Child Routes for Sidebar Menu Items (Non-Dashboard Views)
      // ----------------------------------------------------
      {
        path: 'role-management',
        component: RolemanagementComponent
      },
        {
        path: 'user-accounts',
        component: UseraccountsComponent
      },
      // IMPORTANT: If 'user-management' is needed, ensure the component is imported:
      // {
      //   path: 'user-management',
      //   component: UserManagementComponent // Requires import
      // },
    ]
  },

  // Catch-all route for non-existent paths (uncommented for best practice)
  // { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
